/**
 * Checks if a given string is a valid UUIDv4.
 * @param uid - The string to check.
 * @returns True if the string is a valid UUIDv4, false otherwise.
 */
export const isValidUid = (uid: string | null): boolean => {
  if (!uid) {
    return false;
  }

  const uid4Regex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uid4Regex.test(uid);
};

/**
 * Generates a UUIDv4 string.
 * @returns A UUIDv4 string.
 */
export const generateUid = (): string => {
  const crypto = window.crypto || (window as any).msCrypto;
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);

  // Set the version to 4
  array[6] = (array[6] & 0x0f) | 0x40;
  // Set the variant to 8, 9, A, or B
  array[8] = (array[8] & 0x3f) | 0x80;

  const uid = Array.from(array)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
    .replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, '$1-$2-$3-$4-$5');

  return uid;
};
